import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GoodsInReviewService = {
  async getGoodsInByCode(code) {
    const requestScreenData = {
      url: "api/GoodsIn",
      top: "1",
      expand: "Supplier($select=Name,CurrencyCode)",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getGoodsInDetailByCode(code) {
    const requestScreenData = {
      url: "api/GoodsInDetail",
      filter: `GoodsInCode eq ${code}`,
      top: 1
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(params) {
    var url = "api/GoodsInDetail";
    return ApiService.createDataSource(url, params);
  },

  async getGoodsInBatches(code, lineNo) {
    const requestScreenData = {
      url: "api/GoodsInProductBatch",
      // top: "1",
      filter: `GoodsInCode eq ${code} and GoodsInLineNo eq ${lineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async savePurchaseOrder(payload) {
    var url = `api/Save_GoodsIn`;
    // var url = `api/Save_PickingSlip`;
    return await ApiService.post(url, payload);
  },

  async completeGoodsIn(goodsInCode) {
    return await ApiService.post("api/GoodsIn/CompleteGoodsIn", {
      GoodsInCode: goodsInCode,
    });
  },
};

export { GoodsInReviewService };
